export const UTOPIA_DISCORD_URL = 'https://discord.com/invite/S98sSvEYtw'
export const UTOPIA_SITE_URL = 'https://utopia.csphere.fr'
export const UTOPIA_SERVER_HOST = 'mc.csphere.fr'
/** Hôte Bedrock (Geyser) — port UDP par défaut. */
export const UTOPIA_BEDROCK_HOST = 'mc.csphere.fr'
export const UTOPIA_BEDROCK_PORT = '19132'
export const UTOPIA_CGU_URL = 'https://utopia.csphere.fr'
export const UTOPIA_CONTACT_EMAIL = ''
/** Proxy public avec auth Microsoft (le serveur Utopie local n'expose pas authEndpoint). */
export const UTOPIA_MICROSOFT_AUTH_PROXY = 'https://proxy.mcraft.fun'
